module.exports = __webpack_public_path__ + "img/Maybank.b9c0dc18.png";